import { gql } from "@apollo/client";

const GET_DISPUTE_TRACKING_STATUSES = gql`
  query DisputeTrackingStatuses {
    disputeTrackingStatuses {
      count
      items {
        disputeTrackingStatusId
        disputeTrackingStatusName
        disputeTrackingStatusKey
      }
    }
  }
`;

export default GET_DISPUTE_TRACKING_STATUSES;
